import { useEffect, useState } from 'react';
import axios from 'axios';
import { EmployeeSkillsByCategoryDTO } from '../models/SkillsInterfaces';

export const useGetEmployeeSkills = () => {
  const [employeeSkills, setEmployeeSkills] = useState<
    EmployeeSkillsByCategoryDTO[]
  >([]);
  const [loadingEmployeeSkills, setLoadingEmployeeSkills] = useState(true);

  const getEmployeeSkills = async () => {
    setLoadingEmployeeSkills(true);
    try {
      const response = await axios.get('api/employee-skills/my');
      setEmployeeSkills(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingEmployeeSkills(false);
    }
  };

  useEffect(() => {
    getEmployeeSkills();
  }, []);

  return { employeeSkills, getEmployeeSkills, loadingEmployeeSkills };
};
